'use client'

import { createContext, useContext, type ReactNode } from 'react'

/**
 * Ambient tenant FareHarbor capability, provided once at the layout level so
 * deeply-nested CTA renderers (hero / cta_band / booking_cta) can turn a
 * `fareharbor:` sentinel CTA into a lightbox without threading the tenant
 * through every section variant. `shortname` is the tenant's single source of
 * truth; `enabled` gates whether the lightframe script is loaded.
 */
type FareharborCtx = {
  enabled: boolean
  shortname: string | null
}

const Ctx = createContext<FareharborCtx>({ enabled: false, shortname: null })

export function FareharborProvider({
  enabled,
  shortname,
  children,
}: FareharborCtx & { children: ReactNode }) {
  return <Ctx.Provider value={{ enabled, shortname }}>{children}</Ctx.Provider>
}

export function useFareharbor(): FareharborCtx {
  return useContext(Ctx)
}
